const obtainBoolValue = (key, defaultValue = false) => {
  if (key in process.env) {
    return String(process.env[key]).toLowerCase() === "true";
  }

  return defaultValue;
};

const configWithDatadog = (config, env) => {
  const gatewayUrl = new URL(config.gateway.URL);
  const websocketGatewayUrl = new URL(config.websocketGateway.URL);
  return {
    ...config,
    datadog: {
      applicationId: "00747d82-11f4-4b96-b9a1-008f693b52b0",
      clientToken: "pubc9ed449e75bf778847323bbab6b24f1c",
      site: "datadoghq.com",
      service: "hubly-frontend",
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      trackResources: true,
      trackLongTasks: true,
      trackFrustrations: true,
      trackUserInteractions: true,
      env: env,
      version: process.env.REACT_APP_VERSION || env,
      allowedTracingUrls: [
        `${gatewayUrl.protocol}//${gatewayUrl.host}`,
        `${websocketGatewayUrl.protocol}//${websocketGatewayUrl.host}`,
      ],
    },
  };
};

const selectConfig = (stage) => {
  const local = {
    cognito: {
      REGION: "us-east-1",
      USER_POOL_ID: "us-east-1_ID0gwCmOD",
      APP_CLIENT_ID: "5dl1npival0c935t1e670dljh3",
      IDENTITY_POOL_ID: "us-east-1:1301a5aa-171c-4379-965d-2a6904f86d50",
      COOKIE_DOMAIN: "localhost",
      COOKIE_SECURE: false,
      COOKIE_SAME_SITE: "lax",
    },
    fullStory: { orgId: "RB177", debug: true },
    gateway: { URL: "http://localhost:8000" },
    websocketGateway: { URL: "ws://localhost:3001" },
    intercom: { appId: "udj7iu0x" },
    clientPortal: "localhost:3002",
    clientCardUrl: "http://localhost:5173",
    redtailUrl: "https://smf.crm3.redtailtechnology.com",
    lookerHost: "https://insights.myhubly.com",
    canny: { isTestUser: true, appId: "5c98ff885f23672fdb5e3e5f" },
    userflow: { isTestUser: true, token: "ct_q5b4ae3pgna6naee2cfc4uyzye" },
    launchDarkly: {
      clientSideID: "6056c09582c99b0e4b00f89f",
      anonymousLDUser: {
        key: "anonymous-ld-user",
        email: "anonymousLDUser@myhubly.com",
      },
    },
    newApp: false,
    hubspot: { isTestUser: true },
    chargebee: {
      // https://hubly-test.chargebee.com/apikeys_and_webhooks/api
      site: "hubly-test",
      publishableKey: "test_nvVlUtcurklCizZpLlObDFk9t5FlcuQIR0",
    },
    gtm: { enabled: false },
  };

  const dockerCompose = {
    cognito: {
      REGION: "us-east-1",
      USER_POOL_ID: "us-east-1_ID0gwCmOD",
      APP_CLIENT_ID: "5dl1npival0c935t1e670dljh3",
      IDENTITY_POOL_ID: "us-east-1:1301a5aa-171c-4379-965d-2a6904f86d50",
      COOKIE_DOMAIN: "localhost",
      COOKIE_SECURE: false,
      COOKIE_SAME_SITE: "lax",
    },
    fullStory: null,
    gateway: { URL: "http://workflows:8000" },
    websocketGateway: { URL: "ws://serverless:3001" },
    intercom: null,
    clientPortal: "http://client-portal",
    redtailUrl: "https://smf.crm3.redtailtechnology.com",
    lookerHost: "https://insights.myhubly.com",
    canny: { isTestUser: true, appId: "5c98ff885f23672fdb5e3e5f" },
    userflow: { isTestUser: true, token: "ct_q5b4ae3pgna6naee2cfc4uyzye" },
    launchDarkly: {
      clientSideID: "6056c09582c99b0e4b00f89f",
      anonymousLDUser: {
        key: "anonymous-ld-user",
        email: "anonymousLDUser@myhubly.com",
      },
    },
    hubspot: { isTestUser: true },
    chargebee: {
      site: "hubly-test",
      publishableKey: "test_nvVlUtcurklCizZpLlObDFk9t5FlcuQIR0",
    },
    gtm: { enabled: false },
  };

  const configTemplate = {
    cognito: {
      REGION: process.env.REACT_APP_REGION,
      USER_POOL_ID: process.env.REACT_APP_USER_POOL_ID,
      APP_CLIENT_ID: process.env.REACT_APP_USER_POOL_CLIENT_ID,
      IDENTITY_POOL_ID: process.env.REACT_APP_IDENTITY_POOL_ID,
      COOKIE_DOMAIN: process.env.REACT_APP_COGNITO_COOKIE_DOMAIN,
      COOKIE_SECURE: process.env.REACT_APP_COGNITO_COOKIE_SECURE,
      COOKIE_SAME_SITE: process.env.REACT_APP_COGNITO_COOKIE_SAME_SITE,
    },
    fullStory: {
      orgId: "RB177",
      debug: process.env.REACT_APP_STAGE !== "prod",
    },
    gateway: {
      URL: process.env.REACT_APP_SERVICE_ENDPOINT,
    },
    websocketGateway: {
      URL: process.env.REACT_APP_SERVICE_ENDPOINT_WEBSOCKET,
    },
    intercom: { appId: process.env.REACT_APP_INTERCOM_APP_ID },
    userflow: {
      isTestUser: process.env.REACT_APP_STAGE !== "prod",
      token: process.env.REACT_APP_USERFLOW_TOKEN,
    },
    clientPortal: process.env.REACT_APP_CLIENT_PORTAL,
    clientCardUrl: process.env.REACT_APP_CLIENT_CARD_URL,
    redtailUrl: process.env.REACT_APP_REDTAIL_BASE_URL,
    lookerHost: process.env.REACT_APP_LOOKER_HOST,
    canny: {
      isTestUser: obtainBoolValue(
        "REACT_APP_CANNY_IS_TEST_USER",
        process.env.REACT_APP_STAGE !== "prod"
      ),
      appId: process.env.REACT_APP_CANNY_APP_ID,
    },
    launchDarkly: {
      clientSideID: process.env.REACT_APP_LD_CLIENT_ID,
      anonymousLDUser: {
        key: "anonymous-ld-user",
        email: "anonymousLDUser@myhubly.com",
      },
    },
    isSessionRecordingOn: obtainBoolValue(
      "REACT_APP_ENABLED_SESSION_RECORDING"
    ),
    hubspot: {
      isTestUser: obtainBoolValue(
        `REACT_APP_HUBSPOT_IS_TEST_USER_${stage}`
          .replace("-", "_")
          .toUpperCase(),
        obtainBoolValue(
          "REACT_APP_HUBSPOT_IS_TEST_USER",
          process.env.REACT_APP_STAGE !== "prod"
        )
      ),
    },
    chargebee: {
      site: process.env.REACT_APP_CB_SITE,
      publishableKey: process.env.REACT_APP_CB_PUBLISHABLE_KEY,
    },
    gtm: {
      enabled: obtainBoolValue("REACT_APP_GTM_ENABLED"),
      gtmId: process.env.REACT_APP_GTM_ID,
    },
  };

  const selectBaseConfig = () => {
    switch (stage) {
      case "local":
        return local;
      case "docker-compose":
        return dockerCompose;
      default:
        return configTemplate;
    }
  };

  const withDatadog = obtainBoolValue(
    `REACT_APP_DATADOG_RUM_ENABLED_${stage}`.replace("-", "_").toUpperCase(),
    obtainBoolValue("REACT_APP_DATADOG_RUM_ENABLED", false)
  )
    ? configWithDatadog
    : (c) => {
        return c;
      };

  return withDatadog(selectBaseConfig(), stage);
};

const config = selectConfig(
  "REACT_APP_STAGE" in process.env && process.env.REACT_APP_STAGE !== ""
    ? process.env.REACT_APP_STAGE
    : "local"
);

export default { ...config };
